import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App.tsx";
import { LiffProvider } from "./contexts/LiffContext.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";

// Use dev LIFF ID for localhost, production LIFF ID otherwise
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const liffId = isLocalhost
  ? import.meta.env.VITE_LIFF_ID_DEV || import.meta.env.VITE_LIFF_ID
  : import.meta.env.VITE_LIFF_ID;

if (!liffId) {
  console.error(
    "VITE_LIFF_ID is not set. Please create a .env file with your LIFF ID."
  );
  console.info(
    "For local development, create a LIFF app with endpoint URL: https://localhost:5173/liff"
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60 * 1000, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <LiffProvider liffId={liffId || ""}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LiffProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
